import { render, staticRenderFns } from "./TaskStats.vue?vue&type=template&id=44012886&"
import script from "./TaskStats.vue?vue&type=script&lang=js&"
export * from "./TaskStats.vue?vue&type=script&lang=js&"
import style0 from "./TaskStats.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports